/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetEncountersQuestionsParams,
  GetQuestionsByPageErrorResponse,
  GetQuestionsByPageResponse,
} from './api.schemas';

import { api } from '../util/http';

export const getEncountersQuestions = (
  encounterId: number,
  params?: GetEncountersQuestionsParams,
  signal?: AbortSignal,
) => {
  return api<GetQuestionsByPageResponse>({
    url: `/api/encounters/${encounterId}/questions`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetEncountersQuestionsQueryKey = (
  encounterId?: number,
  params?: GetEncountersQuestionsParams,
) => {
  return [`/api/encounters/${encounterId}/questions`, ...(params ? [params] : [])] as const;
};

export const getGetEncountersQuestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersQuestions>>,
  TError = GetQuestionsByPageErrorResponse,
>(
  encounterId: number,
  params?: GetEncountersQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersQuestions>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersQuestionsQueryKey(encounterId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncountersQuestions>>> = ({ signal }) =>
    getEncountersQuestions(encounterId, params, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersQuestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersQuestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersQuestions>>
>;
export type GetEncountersQuestionsQueryError = GetQuestionsByPageErrorResponse;

export function useGetEncountersQuestions<
  TData = Awaited<ReturnType<typeof getEncountersQuestions>>,
  TError = GetQuestionsByPageErrorResponse,
>(
  encounterId: number,
  params: undefined | GetEncountersQuestionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersQuestions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersQuestions>>,
          TError,
          Awaited<ReturnType<typeof getEncountersQuestions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersQuestions<
  TData = Awaited<ReturnType<typeof getEncountersQuestions>>,
  TError = GetQuestionsByPageErrorResponse,
>(
  encounterId: number,
  params?: GetEncountersQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersQuestions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersQuestions>>,
          TError,
          Awaited<ReturnType<typeof getEncountersQuestions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersQuestions<
  TData = Awaited<ReturnType<typeof getEncountersQuestions>>,
  TError = GetQuestionsByPageErrorResponse,
>(
  encounterId: number,
  params?: GetEncountersQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersQuestions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersQuestions<
  TData = Awaited<ReturnType<typeof getEncountersQuestions>>,
  TError = GetQuestionsByPageErrorResponse,
>(
  encounterId: number,
  params?: GetEncountersQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersQuestions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersQuestionsQueryOptions(encounterId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
